import React from 'react';
import cx from 'classnames';

import Modal from '~/components/modals/modal';
import { Field, Form } from '~/components/form';
import Button from '~/components/button';
import { required, valid } from '~/utils/validation';
import { useFlashMessage } from '~/features/flash-messages/flash-message-actions';
import InputField from '~/components/inputs/input-field';
import { useSession } from '~/features/session/session-actions';
import { useUpdateUser } from '~/features/user/user-actions';
import { analyticsBeacon, EventType } from '~/utils/analytics';

import styles from '~/components/modals/modal.module.scss';

const UpdateNameModal = ({ onClose, isOpen }) => {
  const updateUser = useUpdateUser();
  const { user } = useSession();
  const { showFlashMessage } = useFlashMessage();

  const handleSubmit = async (formValues) => {
    try {
      const { firstName, lastName } = formValues;
      await updateUser({
        email: user.email,
        userInfo: { firstName, lastName },
      });

      showFlashMessage('Your name has been updated.', 'success', 10000);

      onClose();

      analyticsBeacon.emit(EventType.ACCOUNT_UPDATED, {
        userUuid: user.uuid,
        firstName,
        lastName,
        city: user.shippingAddress?.city,
        state: user.shippingAddress?.stateCode,
        zip: user.shippingAddress?.postalCode,
        country: 'US',
        email: user.email,
        formattedAddress: user.shippingAddress?.formatted,
      });
    } catch (err) {
      showFlashMessage(
        'Oops, there was an issue updating your name. Please try again later.'
      );
    }
  };

  return (
    <Modal
      onClose={onClose}
      isOpen={isOpen}
      className={styles.accountInfoModal}
    >
      <h1 className={cx(styles.title, styles.accountInfoModalTitle)}>
        account name
      </h1>
      <Form
        onSubmit={handleSubmit}
        validate={validate}
        resetOnSubmit
        className={styles.accountInfoForm}
        initialValues={{
          firstName: user ? user.firstName : '',
          lastName: user ? user.lastName : '',
        }}
      >
        {({ isSubmitting }) => (
          <>
            <Field label="first name" name="firstName" component={InputField} />

            <Field label="last name" name="lastName" component={InputField} />

            <div className={styles.accountInfoFormButton}>
              <Button type="submit" isLoading={isSubmitting} fullWidth>
                save
              </Button>
            </div>
          </>
        )}
      </Form>
    </Modal>
  );
};

function validate(formValues) {
  return {
    firstName: valid(required())(formValues.firstName),
    lastName: valid(required())(formValues.lastName),
  };
}

export default UpdateNameModal;
